<template>
    <div class="card h-42 w-140 bg-base-100 shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer border border-base-300 hover:border-primary/50"
        :class="{ 'ring-2 ring-primary ring-opacity-50': isSelected }" @click="$emit('select', device)">
        <div class="card-body p-2 flex flex-row gap-2">
            <!-- Main Content -->
            <div class="flex-1">
                <!-- Header with Status -->
                <div class="flex items-start justify-between mb-2 ">
                    <div class="flex items-center gap-2">
                        <div class="avatar placeholder">
                            <div class="bg-primary text-primary-content rounded-full w-6 h-6">
                                <span class="text-xs font-bold"></span>
                            </div>
                        </div>
                        <div>
                            <h3 class="font-bold text-base-content text-xs leading-tight">
                                {{ device.device_name + " - " + device.nickname }}
                            </h3>
                            <p class="text-xs text-base-content/70">{{ device.device_sn }}</p>

                            <!-- Gateway Telemetry Component -->

                        </div>


                    </div>

                    <div class="flex items-center gap-1">
                        <div class="w-2 h-2 rounded-full animate-pulse" :class="gatewayStatusColor"></div>
                        <span class="text-xs font-medium" :class="gatewayStatusTextColor">
                            {{ gatewayStatus }}
                        </span>
                    </div>
                </div>
                <div class="flex bg-base-100 h-4">
                    <GatewayTelemetry :telemetry="gatewayTelemetry" :isOnline="isGatewayOnline" />
                </div>

                <!-- Device Stats -->
                <!--
      <div class="grid grid-cols-2 gap-2 mb-3">
        <div class="bg-base-200 rounded-lg p-2">
          <div class="text-xs text-base-content/70">Tiempo activo</div>
          <div class="text-sm font-semibold text-base-content">98.5%</div>
        </div>
        <div class="bg-base-200 rounded-lg p-2">
          <div class="text-xs text-base-content/70">Señal</div>
          <div class="flex items-center gap-1">
            <div class="text-sm font-semibold text-base-content">85%</div>
            <div class="flex gap-px">
              <div class="w-1 h-3 bg-success rounded-sm"></div>
              <div class="w-1 h-3 bg-success rounded-sm"></div>
              <div class="w-1 h-3 bg-success rounded-sm"></div>
              <div class="w-1 h-3 bg-base-300 rounded-sm"></div>
            </div>
          </div>
        </div>
      </div>
      -->
                <!-- Child Device Info (if exists) -->
                <div v-if="device.children" class="bg-base-200/50 rounded-lg p-2 mb-2">
                    <div class="flex items-center gap-1 mb-1">
                        <div v-if="droneConnected" class="w-1.5 h-1.5 bg-accent rounded-full"></div>
                        <div v-else class="w-1.5 h-1.5 bg-error rounded-full"></div>
                        <span v-if="droneConnected == false"
                            class="text-xs font-medium text-base-content">{{ droneConnectedText }}</span>
                        <span v-else class="text-xs font-medium text-base-content">{{ droneStatus }}</span>
                    </div>
                    <div class="ml-2">
                        <p class="text-xs font-medium text-base-content">{{ device.children.device_name + " - " +
                            device.children.device_sn }}</p>

                        <!-- Drone Telemetry Component -->
                        <DroneTelemetry class="mt-1" :telemetry="droneTelemetry" :isOnline="isDroneOnline" />
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="flex gap-1 h-4 ">
                    <button @click.stop="centerMap" class="btn btn-xs btn-accent flex-1 h-4" title="Centrar en Mapa">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                            </path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        </svg>
                        Centrar
                    </button>
                    <button class="btn btn-xs btn-outline h-4" title="Ver Detalles" @click="openDevice">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Video Section (Right Column) -->
            <div class=" flex w-120 bg-black rounded-lg relative overflow-hidden h-38 ">
                <iframe :src="videoUrlVideo" class="w-full h-full border-0" frameborder="0" allowfullscreen>
                </iframe>
                <div v-if="isDroneOnline" class="absolute top-1 right-1">
                    <div class="bg-red-600 text-white px-1 py-0.5 rounded text-xs font-semibold animate-pulse"
                        @click="toggleVideoType">
                        ● LIVE
                    </div>
                </div>
            </div>

            <!-- Location Info (if available) -->
            <div v-if="device.location" class="mt-3 pt-3 border-t border-base-200">
                <div class="flex items-center gap-2 text-xs text-base-content/70">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                        </path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <span>{{ device.location || 'Ubicación no disponible' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import { computed, onMounted, ref, defineProps, defineEmits } from 'vue'
import { useDevicesStore } from '@/v2/application/stores/devicesStore'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiVideoOff } from '@mdi/js'
import GatewayTelemetry from './GatewayTelemetry.vue'
import DroneTelemetry from './DroneTelemetry.vue'
import { useUserStore } from '@/v2/application/stores/userStore'
import useStore from "@/store";
import router from "@/router";


const store = useStore();
const deviceStore = useDevicesStore()
const userStore = useUserStore()
const props = defineProps({
    device: {
        type: Object,
        required: true
    },
    isSelected: {
        type: Boolean,
        default: false
    }
})

onMounted(() => {
    console.log("Mounted device")
    getCameraIndex();
})

const openDevice = () => {
    store.device_sn = props.device.device_sn;
    store.child_device_sn = props.device.child_device_sn
    store.device = props.device
    //store.setDeviceSn(props.device.device_sn);
    //store.setChildDeviceSn(props.device.child_device_sn);
    //store.setDevice(props.device);
    localStorage.setItem("device", props.device);
    localStorage.setItem("device_sn", props.device.device_sn);
    localStorage.setItem("child_device_sn", props.device.child_device_sn);
    router.push({
        path: "workspace",
    });
}


const gatewaySn = computed(() => {
    return props.device.device_sn
})

const droneSn = computed(() => {
    return props.device.children?.device_sn
})

const gatewayConnected = computed(() => {
    return deviceStore.getDeviceConnected(gatewaySn.value)
})

const droneConnected = computed(() => {
    return deviceStore.getDeviceConnected(droneSn.value)
})

const gatewayStatus = computed(() => {
    const status = deviceStore.getDeviceModeCode(gatewaySn.value)
    if (status == -1) {
        return "Unknown"
    }
    const statusLabels = {
        0: "Idle",
        1: "On-site debugging",
        2: "Remote debugging",
        3: "Firmware upgrade in progress",
        4: "In operation",
        5: "To be calibrated"
    }
    return statusLabels[status] ?? status
})

const droneStatus = computed(() => {
    const status = deviceStore.getDeviceModeCode(droneSn.value)
    if (status == -1) {
        return "Unknown"
    }
    const statusLabels = {
        0: "Standby",
        1: "Takeoff preparation",
        2: "Takeoff preparation completed",
        3: "Manual flight",
        4: "Automatic takeoff",
        5: "Wayline flight",
        6: "Panoramic photography",
        7: "Intelligent tracking",
        8: "ADS-B avoidance",
        9: "Auto returning to home",
        10: "Automatic landing",
        11: "Forced landing",
        12: "Three-blade landing",
        13: "Upgrading",
        14: "Not connected",
        15: "APAS",
        16: "Virtual stick state",
        17: "Live flight Controls",
        18: "Airborne RTK fixing mode",
        19: "Dock address selecting"
    }
    return statusLabels[status] ?? status
})



const emit = defineEmits(['select', 'centerMap'])

const centerMap = () => {
    emit('centerMap', props.device)
}

// Gateway telemetry
const gatewayTelemetry = computed(() => {
    return deviceStore.getDeviceTelemetry(props.device.device_sn) || {}
})

const isGatewayOnline = computed(() => {
    return deviceStore.getDeviceConnected(props.device.device_sn)
})

// Drone telemetry
const droneTelemetry = computed(() => {
    if (!props.device.children) return {}
    return deviceStore.getDeviceTelemetry(props.device.children.device_sn) || {}
})

const isDroneOnline = computed(() => {
    if (!props.device.children) return false
    return deviceStore.getDeviceConnected(props.device.children.device_sn)
})

// Video URL - por definir
const videoUrl = computed(() => {
    // URL por definir - aquí se puede agregar la lógica para generar la URL del video
    return 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&mute=1'
})

const deviceInitials = computed(() => {
    return props.device.device_name
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 2)
})

const videoType = ref('detections')

const toggleVideoType = () => {
    if (videoType.value == 'detections') {
        videoType.value = 'original'
    } else {
        videoType.value = 'detections'
    }
}
const getVideoUrl = () => {
    if (videoType.value == 'detections') {
        return "https://media2.cvis.videri.ai/"
    } else {
        return "https://media.cvis.videri.ai/"
    }
}

const getVideoSn = () => {
    return props.device.children.device_sn;
}

const getCameraIndex = () => {
    const cameraIndex = droneTelemetry.value["cameras.0.payload_index"]
    return cameraIndex
}

const videoUrlVideo = computed(() => {
    const cameraIndex = getCameraIndex();
    if (cameraIndex === undefined) {
        return null;
    }
    const username = userStore.getUsername();
    const password = userStore.getPassword();
    // baseurl DONE
    // videotype DONE
    // devicesn DONE
    // cameraselectedindex
    // _normal-0?user={}&password={}
    return getVideoUrl() + videoType.value + "/" + getVideoSn() + "_" + cameraIndex + "_normal-0?user=" + username + "&password=" + password;
});

const droneConnectedText = computed(() => {
    console.log(droneConnected.value)
    return droneConnected.value ? 'Conectado' : 'Desconectado'
})


const gatewayStatusColor = computed(() => {
    return gatewayConnected ? 'bg-success' : 'bg-error'
})

const droneStatusColor = computed(() => {
    return droneConnected ? 'bg-success' : 'bg-error'
})

const gatewayStatusTextColor = computed(() => {
    return gatewayConnected ? 'text-success' : 'text-error'
})
const droneStatusTextColor = computed(() => {
    return droneConnected ? 'text-success' : 'text-error'

})

</script>

<style scoped>
.card-body {
    min-width: 0;
}
</style>
